<template>
    <div>
    <header class="mdc-top-app-bar top-app-bar top-header">
        <div class="mdc-top-app-bar__row">
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <!-- <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"
                    aria-label="Open navigation menu">menu</button>-->
                <span class="mdc-top-app-bar__title t-subtitle4 pdl-18">BRAND NAME</span>
            </section>
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
                <!-- <div class="profile d-flex align-items-center mgr-24"><img src="images/avtar.svg"
                        class="w-32 h-32 circle mgr-16" alt="">
                    <div class="t-body2 t-color-white">USER ID</div>
                </div> -->
                <div class=" t-body2 t-color-white pdr-18">LOGIN</div>
                <!-- <div class=" t-body2 t-color-appbarText pdr-18">LOGOUT</div> -->
            </section>
        </div>
    </header>
    <div class="d-flex h-full flex-column">
        <main class="main-wrapper full flex-grow-1 scroll-y">

            <div class="container container--small pdt-50 ">
                <div class="t-headline11 font-m mgb-18 pdl-24 pdr-24">개인정보보호 정책</div>
                <div class="t-body1 t-color-bodyGrayA font-r mgt-6 pdl-24 pdr-24 t-line-h-26 l-spacing48">제 2 조 (약관의 효력과
                    변경)<br><br>

                    1. 기업마당 사이트는 귀하가 본 약관 내용에 동의하는 경우 기업마당 사이트의 서비스 제공 행위 및 귀하의 서비스 사용 행위에 본 약관이 우선적으로 적용됩니다.
                    <br><br>
                    2. 기업마당 사이트는 본 약관을 사전 고지 없이 변경할 수 있고 변경된 약관은 기업마당 사이트 내에 공지하거나 e-mail을 통해 회원에게 공지하며, 공지와 동시에 그 효력이
                    발생됩니다.
                    이용자가 변경된 약관에 동의하지 않는 경우, 이용자는 본인의 회원등록을 취소 (회원탈락)할 수 있으며 계속 사용의 경우는 약관 변경에 대한 동의로 간주 됩니다.제 2 조 (약관의
                    효력과 변경)
                    <br><br>
                    1. 기업마당 사이트는 귀하가 본 약관 내용에 동의하는 경우 기업마당 사이트의 서비스 제공 행위 및 귀하의 서비스 사용 행위에 본 약관이 우선적으로 적용됩니다.
                    <br><br>
                    2. 기업마당 사이트는 본 약관을 사전 고지 없이 변경할
                </div>
                <div class="t-body3 t-color-bodyGrayA font-r mgt-24 pdl-24 pdr-24 ">발효일: 2020년 02월 18일
                </div>

                <div class="mgt-50 mgb-50 pdl-24">
                    <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4">
                        <div class="mdc-button__ripple"></div>
                        <span class="mdc-button__label t-body2 font-r">확인</span>
                    </button>
                </div>
            </div>
        </main>
    </div>
    <router-view></router-view>
    </div>
    
</template>

<script>
/**
 * 개인정보 취급방침 컴포넌트(Privacy Policy Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import joinApi from '@/api/joinApi.js'

export default {
    components: {
        TopAppBar
    },
    data() {
        return {
            // title: '개인정보 보호정책',
            title: this.$t('1224'),
            htmlPrivacypolicy: null,
            year:'',
            month:'',
            day:'',
        }
    },

    mixins: [topAppBarMixin],
    mounted() {
        this.setTopAppBarCloseOnly(this.title)

        // 약관정보 API 호출(call api Privacy Policy )
        joinApi.terms().then((response) => {
            // console.log(response.data.data)
            const termsUrl = response.data.data.TERMS_OF_SERVICE;
            const privacyUrl = response.data.data.PRIVACY_STATEMENT;

            joinApi.policyContents(privacyUrl,'text').then((response) => {
                this.htmlPrivacypolicy = response.data
            })            
        }).catch((err) => {
        })
        let params = {type:'PRIVACY_STATEMENT'};
        joinApi.termsDate(params).then((response) => {
            if(response.data.data){
                this.year = this.$moment(response.data.data).format("Y");
                this.month = this.$moment(response.data.data).format("MM");
                this.day = this.$moment(response.data.data).format("DD");
            }
        }).catch((err) => { console.log('err=>',err)})
    }

}
</script>